import React, { useEffect, useState } from "react";
import { Box, Divider, Grid, Tooltip, Typography, Skeleton } from "@mui/material";
import PaperCard from "../../../components/ui/PaperCard";
import HighchartsComponent from "../../../components/ui/HighchartsComponent";
import { useDispatch, useSelector } from "react-redux";
import { SecondaryButton } from "../../../components/ui/Button";
import ModalPopup from "../../../components/ui/ModalPopup";
import service from "../../../services/api/service";
import PDFViewer from "../../../components/ui/PDFViewer";
import { formatIndianRupees, handlePercentAmountFlexi, checkPercentage, flexiCheckPercentage } from "../../../utils/formatting";
import queryString from "query-string";
import LoaderBackdrop from "../../../components/ui/LoaderBackdrop";
import { formatDate } from "../../../utils/dateFormatUtils";
import { setaccountSummaryData } from "../../../services/redux/slices/accountSummarySlice";
import dayjs from "dayjs";
import postsServices from "../../../services/api/service/postsService";
import { authSelector } from "../../../services/redux/slices/authSlice";
import ChartSideView from "./ChartSideView";
import { RootState } from "../../../services/redux/store";
import { decrypt } from "../../../utils/crypto";
import Card from "../../../components/ui/Card";
import { styled } from "@mui/material/styles";
import { LinearProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import UtilizedIcon from "../../../assets/images/icons/utilized.png";
import AvailableIcon from "../../../assets/images/icons/available.png";
import Breadcrumbs from "../../../components/ui/Breadcrumbs";


interface QueryParams {
  LAN: string | null;
}

interface BeneficiaryData {
  acHolderName: string;
  bankName: string;
  accountNo: string;
  ifsc: string;
  disbAmount: any;
}

interface CoBorrower {
  cif: string;
  shortName: string;
  includeRepay: boolean;
  authoritySignatory: boolean;
  sequence: number;
  version: number;
  includeIncome: boolean;
}

interface Payload {
  finReference: string;
  fromDate: string | null;
  toDate: string | null;
  type: string;
  cif: string;
  action: string;
  finActiveStatus: string;
  loanCat: string;
}
const AccountSummary = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [pdfUrlAccountStatement, setPdfUrlAccountStatement] =
    useState<string>("");
  const selectedOption = useSelector(
    (state: RootState) => state?.option?.selectedOption
  );
  const { userProfile } = useSelector(authSelector);

  const accountSummaryData = useSelector(
    (state: RootState) => state?.accountSummaryData?.sanctionedDisbursedData
  );
  const loanAccountNumberOptions = useSelector(
    (state: RootState) => state?.option?.loanAccountNumberOptions
  );
  // const loanData = useSelector((state: RootState) => state.option.loanData);
  const [acountsummaryData, setAcountsummaryData] = useState<any[]>([]);
  const [beneficiary, setBeneficiary] = useState<BeneficiaryData | null>(null);
  // const [loader, setLoader] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));

  const breadcrumbItems = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Account Summary", path: "/dashboard/account-summary" }
  ];

  const dummyPdfUrl2 = "";
  const dispatch = useDispatch();
  useEffect(() => {
    // Fetch data on page load
    if (loanAccountNumberOptions && loanAccountNumberOptions.length > 0) {
      const initialLAN = loanAccountNumberOptions[0]; // Default to first LAN
      // fetchAccountSummary(initialLAN);
    }
  }, [loanAccountNumberOptions]); // Trigger when loanAccountNumberOptions change

  useEffect(() => {
    // Fetch data when selectedOption changes
    if (
      selectedOption &&
      loanAccountNumberOptions &&
      loanAccountNumberOptions?.length > 0
    ) {
      const selectedLAN = loanAccountNumberOptions?.find(
        (option: any) => option === selectedOption
      );
      if (selectedLAN) {
        // fetchAccountSummary(selectedLAN);
      }
    }
  }, [selectedOption]);
  const selectedLoanNumber = useSelector(
    (state: RootState) => state?.dashboardData?.selectedLoanNumber
  );
  useEffect(() => {
    const queryParams: QueryParams = { LAN: selectedLoanNumber };
    const queryParamsString = queryString.stringify(queryParams);
    // setIsLoading(true);
    service.posts
      .getPosts(`api/v1/dashboard/getAccountSummary?${queryParamsString}`)
      .then((response) => {
        const data = response?.data?.data || [];
        setAcountsummaryData(data);
        dispatch(setaccountSummaryData(data));
        if (
          data?.length > 0 &&
          data[0]?.beneficiaryName &&
          data[0]?.beneficiaryName?.length > 0
        ) {
          const firstBeneficiary = data[0]?.beneficiaryName[data[0]?.beneficiaryName.length - 1];
          const beneficiaryData: BeneficiaryData = {
            acHolderName: firstBeneficiary?.acHolderName || "N/A",
            bankName: firstBeneficiary?.bankName || "N/A",
            accountNo: firstBeneficiary.accountNo || "N/A",
            ifsc: firstBeneficiary?.ifsc || "N/A",
            disbAmount: firstBeneficiary?.disbAmount || "N/A",
          };
          setBeneficiary(beneficiaryData);
          setIsLoading(false);
        } else {
          setBeneficiary(null);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }, [selectedLoanNumber]);
  const handleViewStatementClick = () => {
    let toDate = new Date();
    const formattedToDate = toDate ? dayjs(toDate).format("YYYY-MM-DD") : null;
    const payLoad: Payload = {
      finReference: selectedLoanNumber,
      fromDate: accountSummaryData[0]?.beneficiaryName[0]?.disbDate,
      toDate: formattedToDate,
      type: "soa",
      cif: decrypt(userProfile?.cifNumber),
      action: "view",
      finActiveStatus: "",
      loanCat: "flexi",
    };
    setIsLoading(true);
    postsServices
      .addPost("api/v1/report/accountstatement", payLoad)
      .then((response) => {
        let successMessage = response?.data?.message || "success";
        const pdfUrl = response?.data?.data?.url;
        viewPdf(pdfUrl);
        setIsLoading(false);
        setIsModalOpen(true);
      })
      .catch((error) => { });
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const viewPdf = async (pdfUrl: string) => {
    try {
      const httpsUrl = pdfUrl.replace(/^http:\/\//i, "https://");
      const response = await fetch(httpsUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch PDF: ${response.statusText}`);
      }
      const blob = await response?.blob();
      const url = window?.URL?.createObjectURL(blob);
      setPdfUrlAccountStatement(pdfUrl);
    } catch (error) {
      setIsLoading(false);
      console.error("Error sending email:", error);
    }
  };

  const MultiColorProgressBar = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    backgroundColor: "rgba(22, 135, 148, 1)",
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgba(254, 193, 13, 1)",
    },
  }));

  const MultiColorProgressBarMobile = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: "5px",
    backgroundColor: "rgba(22, 135, 148, 1)", // Available background
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgba(254, 193, 13, 1)", // Utilized color
    },
  }));

  // Extract the Utilised/Available Amount section
  const UtilizedAvailableSection = (
    <Grid item xs={12} sm={5} md={5} lg={5}>
      <div style={{ display: "flex" }}>
        {!isXsOrSm && (
          <div className="line-container">
            <div className="line vertical"></div>
            <div className="line vertical"></div>
          </div>
        )}
        <Grid container sm className="muiLinearProgress">
          {/* Utilised Section */}
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            lg={6}
            className="right-border"
          >
            <Typography className="mainHeadingLable muiLinear-progress-p">
              <img
                src={UtilizedIcon}
                alt="Available"
                style={{
                  height: "22px",
                }}
              />
              <span className="left-side-span">
                Utilised Amount
              </span>{" "}
            </Typography>
            <Typography className="mainHeadingValue">
              {formatIndianRupees(
                accountSummaryData[0]?.limitUtilization
              )}
            </Typography>
            {/* Calculate and display the dynamic percentage */}
            <Typography className="mainHeadingPerValue">
              {handlePercentAmountFlexi(
                accountSummaryData[0]?.totalLimit,
                accountSummaryData[0]?.limitUtilization,
                accountSummaryData[0]?.availableLimit,
                "disburse"
              )}
              % used
            </Typography>
          </Grid>

          {/* Available Section */}
          <Grid item xs={6} sm={6} md={6} lg={6}>
            <Typography
              className="mainHeadingLable"
              style={{ textAlign: "right" }}
            >
              <span className="mainHeadingLableSpan">
                Available Amount
              </span>
              <img
                src={AvailableIcon}
                alt="Available"
                style={{
                  height: "22px",
                }}
              />
            </Typography>

            <div className="muiLinear-progress-div">
              <Typography className="mainHeadingValue text-align-right mainHeadingValueRight">
                {formatIndianRupees(
                  accountSummaryData[0]?.availableLimit
                )}
              </Typography>
              {/* Calculate and display the dynamic percentage */}
              <Typography className="mainHeadingPerValue text-align-right">
                {handlePercentAmountFlexi(
                  accountSummaryData[0]?.totalLimit,
                  accountSummaryData[0]?.limitUtilization,
                  accountSummaryData[0]?.availableLimit,
                  "sanction"
                )}
                % left
              </Typography>
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box sx={{ width: "100%", marginTop: 3 }}>
              <MultiColorProgressBar
                variant="determinate"
                value={flexiCheckPercentage(accountSummaryData[0])}
              />
            </Box>
          </Grid>

        </Grid>
      </div>
    </Grid>
  );

  const handleVariation = (key: string) => {

    switch (key) {
      case "P":
        return "Normal"
      case "D":
        return "Drop"
      case "H":
        return "Hybrid"
      default:
        return "Normal"
    }

  }


  // Create a comprehensive skeleton component
  const AccountSummarySkeleton = () => (
    <>
      {/* Breadcrumbs skeleton */}
      <Box sx={{ mb: 2 }}>
        <Skeleton variant="text" width={200} height={24} />
      </Box>

      {/* Main Card Skeleton */}
      <Card borderColor={true} marginBottom="20px">
        <Grid container>
          <Grid item xs={12} sm={8}>
            <Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="40%" height={20} />
          </Grid>
        </Grid>
        <Grid container sx={{ paddingTop: "30px" }}>
          <Grid item xs={12}>
            <Divider sx={{ border: "1px solid rgba(219, 218, 222, 1)", width: "100%" }} />
          </Grid>
        </Grid>
        {/* Borrower info skeleton */}
        <Box className="box-container dashboard-container">
          <Grid container>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="60%" height={20} />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="70%" height={20} />
            </Grid>
          </Grid>
        </Box>

        {/* Loan details and utilized/available section */}
        <Grid container className="dashboard-container">
          {isXsOrSm ? (
            <>
              {/* Mobile layout - Utilized/Available section first */}
              <Grid item xs={12} sm={5} md={5} lg={5}>
                <div style={{ display: "flex" }}>
                  <Grid container sm className="muiLinearProgress">
                    <Grid item xs={6} sm={6} md={6} lg={6} className="right-border">
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Skeleton variant="circular" width={22} height={22} sx={{ mr: 1 }} />
                        <Skeleton variant="text" width="60%" height={16} />
                      </Box>
                      <Skeleton variant="text" width="70%" height={24} sx={{ mb: 0.5 }} />
                      <Skeleton variant="text" width="40%" height={16} />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', mb: 1 }}>
                        <Skeleton variant="text" width="60%" height={16} />
                        <Skeleton variant="circular" width={22} height={22} sx={{ ml: 1 }} />
                      </Box>
                      <Box sx={{ textAlign: 'right' }}>
                        <Skeleton variant="text" width="70%" height={24} sx={{ mb: 0.5 }} />
                        <Skeleton variant="text" width="40%" height={16} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Box sx={{ width: "100%", marginTop: 3 }}>
                        <Skeleton variant="rectangular" height={10} sx={{ borderRadius: 1 }} />
                      </Box>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              {/* Mobile layout - Loan details grid */}
              <Grid item xs={12} sx={{ marginTop: "10px" }}>
                <Grid container spacing={2}>
                  {[1, 2, 3].map((item) => (
                    <Grid item xs={4} key={item}>
                      <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
                      <Skeleton variant="text" width="60%" height={20} />
                    </Grid>
                  ))}
                </Grid>
                <Grid container spacing={2}>
                  {[1, 2, 3].map((item) => (
                    <Grid item xs={4} key={item}>
                      <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
                      <Skeleton variant="text" width="60%" height={20} />
                    </Grid>
                  ))}
                </Grid>
                <Grid container spacing={2}>
                  {[1, 2, 3].map((item) => (
                    <Grid item xs={4} key={item}>
                      <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
                      <Skeleton variant="text" width="60%" height={20} />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              {/* Desktop layout - Loan details first */}
              <Grid item xs={12} sm={7}>
                <Grid container spacing={2}>
                  {[1, 2, 3].map((item) => (
                    <Grid item xs={4} key={item}>
                      <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
                      <Skeleton variant="text" width="60%" height={20} />
                    </Grid>
                  ))}
                </Grid>
                <Grid container spacing={2}>
                  {[1, 2, 3].map((item) => (
                    <Grid item xs={4} key={item}>
                      <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
                      <Skeleton variant="text" width="60%" height={20} />
                    </Grid>
                  ))}
                </Grid>
                <Grid container spacing={2}>
                  {[1, 2, 3].map((item) => (
                    <Grid item xs={4} key={item}>
                      <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
                      <Skeleton variant="text" width="60%" height={20} />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              {/* Desktop layout - Utilized/Available section */}
              <Grid item xs={12} sm={5} md={5} lg={5}>
                <div style={{ display: "flex" }}>
                  <div className="line-container">
                    <div className="line vertical"></div>
                    <div className="line vertical"></div>
                  </div>
                  <Grid container sm className="muiLinearProgress">
                    <Grid item xs={6} sm={6} md={6} lg={6} className="right-border">
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Skeleton variant="circular" width={22} height={22} sx={{ mr: 1 }} />
                        <Skeleton variant="text" width="60%" height={16} />
                      </Box>
                      <Skeleton variant="text" width="70%" height={24} sx={{ mb: 0.5 }} />
                      <Skeleton variant="text" width="40%" height={16} />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', mb: 1 }}>
                        <Skeleton variant="text" width="60%" height={16} />
                        <Skeleton variant="circular" width={22} height={22} sx={{ ml: 1 }} />
                      </Box>
                      <Box sx={{ textAlign: 'right' }}>
                        <Skeleton variant="text" width="70%" height={24} sx={{ mb: 0.5 }} />
                        <Skeleton variant="text" width="40%" height={16} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Box sx={{ width: "100%", marginTop: 3 }}>
                        <Skeleton variant="rectangular" height={10} sx={{ borderRadius: 1 }} />
                      </Box>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </>
          )}
        </Grid>
      </Card>

      {/* Loan Details Card Skeleton */}
      <Card marginBottom="20px">
        <Skeleton variant="text" width="30%" height={28} sx={{ mb: 2 }} />
        <Grid container className="dashboard-container" style={{ background: "transparent" }}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {[1, 2, 3, 4].map((item) => (
                <Grid item xs={6} sm={6} md={3} lg={3} key={item}>
                  <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width="60%" height={20} />
                </Grid>
              ))}
            </Grid>
            <Grid container spacing={2}>
              {[1, 2, 3].map((item) => (
                <Grid item xs={6} sm={6} md={3} lg={3} key={item}>
                  <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width="60%" height={20} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Card>

      {/* Last Disbursement Details Card Skeleton */}
      <Card marginBottom="20px">
        <Skeleton variant="text" width="35%" height={28} sx={{ mb: 2 }} />
        <Grid container className="dashboard-container" style={{ background: "transparent" }}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {[1, 2, 3, 4].map((item) => (
                <Grid item xs={6} sm={6} md={3} lg={3} key={item}>
                  <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width="60%" height={20} />
                </Grid>
              ))}
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={6} md={3} lg={3}>
                <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
                <Skeleton variant="text" width="60%" height={20} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </>
  );

  return (
    <React.Fragment>
      <Breadcrumbs items={breadcrumbItems} />

      <Grid container className="mt-20 account-summary-term">
        {isLoading ? (
          <AccountSummarySkeleton />
        ) : (
          <>
            <Card borderColor={true} marginBottom="20px">
              <Grid container>
                <Grid item xs={12} sm={8}>
                  <Typography className="loan-account-main-heading mb-5">
                    Loan A/C {selectedLoanNumber}
                  </Typography>
                  <Typography className="loan-account-sub-heading">
                    {acountsummaryData[0]?.description}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container sx={{ paddingTop: "30px" }}>
                <Grid item xs={12}>
                  <Divider sx={{ border: "1px solid rgba(219, 218, 222, 1)", width: "100%" }} />
                </Grid>
              </Grid>
              {acountsummaryData?.map((item, index) => (
                <Box className="box-container dashboard-container" key={index}>
                  <Grid container>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Typography className="insidePageLable">Borrower name</Typography>
                      <Typography className="insidePageValue">{item.borrowerName}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Typography className="insidePageLable">Co-Borrower</Typography>
                      <Tooltip
                        arrow
                        enterTouchDelay={50}
                        title={
                          <React.Fragment>
                            {item?.coBorroewer?.map((cb: any) => (
                              <div key={cb.cif}>
                                <Typography variant="subtitle2">{cb.shortName}</Typography>
                              </div>
                            ))}
                          </React.Fragment>
                        }
                        placement="top"
                        PopperProps={{ style: { transformOrigin: "center top" }, placement: "top-start" }}
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "common.white",
                              "& .MuiTooltip-arrow": { color: "common.white" },
                              color: "#808080",
                              fontSize: "16px",
                              fontWeight: "400",
                              width: "500px",
                              boxShadow: "-24px -12px 59px 0px #0000001A",
                              border: "1px solid #E6E6E6",
                            },
                          },
                        }}
                      >
                        <div>
                          {item?.coBorroewer?.slice(0, 3)?.map((value: any, i: number) => (
                            <span key={value.cif} className="insidePageValue">
                              {value.shortName}
                              {i < 2 && i !== item?.coBorroewer?.slice(0, 3).length - 1 && ","}
                            </span>
                          ))}
                          {item?.coBorroewer?.length > 3 && (
                            <span className="insidePageValue">{" ..."}</span>
                          )}
                        </div>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Box>
              ))}
              <Grid container className="dashboard-container">
                {isXsOrSm ? (
                  <>
                    {UtilizedAvailableSection}
                    <Grid item xs={12} sx={{ marginTop: "10px" }}>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Product type</Typography>
                          <Typography className="insidePageValue">{acountsummaryData[0]?.productType || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Total limit</Typography>
                          <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.totalLimit) || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">ROI</Typography>
                          <Typography className="insidePageValue">{acountsummaryData[0]?.ROI}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Available limit</Typography>
                          <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.availableLimit) || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Tenure (in months)</Typography>
                          <Typography className="insidePageValue">{acountsummaryData[0]?.tenure || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Processing fees</Typography>
                          <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.processingFee) || "N/A"}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Loan start date</Typography>
                          <Typography className="insidePageValue">{acountsummaryData[0]?.finStartDate}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Variant</Typography>
                          <Typography className="insidePageValue">{handleVariation(acountsummaryData[0]?.variant)}</Typography>
                        </Grid>
                        {acountsummaryData[0]?.AMC !== 0 && (
                          <Grid item xs={4}>
                            <Typography className="insidePageLable">AMC</Typography>
                            <Typography className="insidePageValue">{acountsummaryData[0]?.AMC}%</Typography>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={12} sm={7}>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Product type</Typography>
                          <Typography className="insidePageValue">{acountsummaryData[0]?.productType || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Total limit</Typography>
                          <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.totalLimit) || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">ROI</Typography>
                          <Typography className="insidePageValue">{acountsummaryData[0]?.ROI}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Available limit</Typography>
                          <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.availableLimit) || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Tenure (in months)</Typography>
                          <Typography className="insidePageValue">{acountsummaryData[0]?.tenure || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Processing fees</Typography>
                          <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.processingFee) || "N/A"}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Loan start date</Typography>
                          <Typography className="insidePageValue">{acountsummaryData[0]?.finStartDate}</Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography className="insidePageLable">Variant</Typography>
                          <Typography className="insidePageValue">{handleVariation(acountsummaryData[0]?.variant)}</Typography>
                        </Grid>
                        {acountsummaryData[0]?.AMC !== 0 && (
                          <Grid item xs={4}>
                            <Typography className="insidePageLable">AMC</Typography>
                            <Typography className="insidePageValue">{acountsummaryData[0]?.AMC}%</Typography>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                    {UtilizedAvailableSection}
                  </>
                )}
              </Grid>
            </Card>
            <Card marginBottom="20px">
              <Typography className="mb-20 section-heading">Loan Details</Typography>
              <Grid container className="dashboard-container" style={{ background: "transparent" }}>
                <Grid item xs={12}>
                  {isXsOrSm && 
                  <>
                   <Grid container spacing={2}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Total paid amount</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.totalRepaymentAmount) || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Total outstanding</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.totalOutstandingAmount) || "N/A"}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Next repayment amount</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.nextRepaymentAmount) || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Total principal amount (Paid)</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.paidPri) || "N/A"}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Total principal outstanding</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.totalPrincipalOutstanding) || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Loan start date</Typography>
                      <Typography className="insidePageValue">{formatDate(acountsummaryData[0]?.finStartDate) || "N/A"}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Next Repayment Schedule Date</Typography>
                      <Typography className="insidePageValue">{formatDate(acountsummaryData[0]?.nextScheduleDate) || "N/A"}</Typography>
                    </Grid>
                  </Grid></>}
                {!isXsOrSm && 
                  <>
                   <Grid container spacing={2}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Total paid amount</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.totalRepaymentAmount) || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Total outstanding</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.totalOutstandingAmount) || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Next repayment amount</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.nextRepaymentAmount) || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Total principal amount (Paid)</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.paidPri) || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Total principal outstanding</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(acountsummaryData[0]?.totalPrincipalOutstanding) || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Loan start date</Typography>
                      <Typography className="insidePageValue">{formatDate(acountsummaryData[0]?.finStartDate) || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Next Repayment Schedule Date</Typography>
                      <Typography className="insidePageValue">{formatDate(acountsummaryData[0]?.nextScheduleDate) || "N/A"}</Typography>
                    </Grid>
                  </Grid></>}
                </Grid>
              </Grid>
            </Card>
            <Card marginBottom="20px">
              <Typography className="mb-20 section-heading">Last Disbursement Details</Typography>
              <Grid container className="dashboard-container" style={{ background: "transparent" }}>
                <Grid item xs={12}>
                   {isXsOrSm &&  <>
                   <Grid container spacing={2}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Beneficiary name</Typography>
                      <Typography className="insidePageValue">{beneficiary?.acHolderName || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Account number</Typography>
                      <Typography className="insidePageValue">{beneficiary?.accountNo || "N/A"}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Bank name</Typography>
                      <Typography className="insidePageValue">{beneficiary?.bankName || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">IFSC code</Typography>
                      <Typography className="insidePageValue">{beneficiary?.ifsc || "N/A"}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Disbursement amount</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(beneficiary?.disbAmount) || "N/A"}</Typography>
                    </Grid>
                  </Grid>
                  </>
                    }
                    {!isXsOrSm &&  <>
                   <Grid container spacing={2}>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Beneficiary name</Typography>
                      <Typography className="insidePageValue">{beneficiary?.acHolderName || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Account number</Typography>
                      <Typography className="insidePageValue">{beneficiary?.accountNo || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Bank name</Typography>
                      <Typography className="insidePageValue">{beneficiary?.bankName || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">IFSC code</Typography>
                      <Typography className="insidePageValue">{beneficiary?.ifsc || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3}>
                      <Typography className="insidePageLable">Disbursement amount</Typography>
                      <Typography className="insidePageValue">{formatIndianRupees(beneficiary?.disbAmount) || "N/A"}</Typography>
                    </Grid>
                  </Grid>
                  </>
                    }
                </Grid>
              </Grid>
            </Card>
          </>
        )}
      </Grid>
      <ModalPopup
        onNavigate={() => { }}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title="View details"
        style={{ minWidth: "850px" }}
      >
        <PDFViewer pdfUrl={pdfUrlAccountStatement} />
      </ModalPopup>
      {/* <LoaderBackdrop open={isLoading} /> */}
    </React.Fragment>
  );
};

export default AccountSummary;
